module.exports = __webpack_public_path__ + "img/logo-150x150.3e8de9a3.png";